import React from "react"

export interface HeaderProps {
	children: JSX.Element | JSX.Element[] | null
}

export function Header(props: HeaderProps): JSX.Element {

	return (
		<section className="header">
			<h1>Spirit Island stats</h1>
			<React.Fragment>
				{props.children}
			</React.Fragment>
		</section>
	)
}
